// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type PremiumFeaturesOverviewQueryVariables = Types.Exact<{
  platform?: Types.InputMaybe<Types.PremiumPlatform>;
  product?: Types.InputMaybe<Types.PremiumFeaturesOverviewProducts>;
}>;

export type PremiumFeaturesOverviewQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Viewer';
    id: string;
    premiumFeaturesOverview?: {
      __typename?: 'PremiumFeaturesOverview';
      collection?: Array<{
        __typename?: 'PremiumFeaturesOverviewArea';
        header?: string | null;
        trackingId?: string | null;
        groups?: Array<{
          __typename?: 'PremiumFeaturesOverviewGroup';
          header?: string | null;
          trackingId?: string | null;
          subheader?: string | null;
          imageUrl?: string | null;
          darkImageUrl?: string | null;
          featureUrl?: {
            __typename?: 'PremiumFeaturesOverviewFeatureUrl';
            url?: string | null;
            text?: string | null;
          } | null;
          items?: Array<{
            __typename?: 'PremiumFeaturesOverviewItem';
            text?: string | null;
            specialText?: string | null;
            values?: Array<{
              __typename?: 'PremiumFeaturesOverviewItemValue';
              enabled?: boolean | null;
              maxUsage?: number | null;
            } | null> | null;
          } | null> | null;
          tipsAndTricks?: Array<{
            __typename?: 'PremiumFeaturesOverviewTipsAndTricks';
            text?: string | null;
            videoId?: number | null;
            top?: {
              __typename?: 'PremiumFeaturesOverviewTipsAndTricksSection';
              header?: string | null;
              actions?: Array<{
                __typename?: 'PremiumFeaturesOverviewTipsAndTricksAction';
                url?: string | null;
                text?: string | null;
                trackingId?: string | null;
              } | null> | null;
            } | null;
            bottom?: {
              __typename?: 'PremiumFeaturesOverviewTipsAndTricksSection';
              header?: string | null;
              actions?: Array<{
                __typename?: 'PremiumFeaturesOverviewTipsAndTricksAction';
                url?: string | null;
                text?: string | null;
                trackingId?: string | null;
              } | null> | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export const PremiumFeaturesOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PremiumFeaturesOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'platform' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PremiumPlatform' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'product' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PremiumFeaturesOverviewProducts' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'premiumFeaturesOverview' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'platform' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'platform' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'product' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'product' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'header' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'trackingId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'header' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'trackingId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subheader' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageUrl' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'darkImageUrl',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'featureUrl' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'url' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'text' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'text' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'specialText',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'values',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'enabled',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'maxUsage',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'tipsAndTricks',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'text' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'videoId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'top' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'header',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'actions',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'text',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'trackingId',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'bottom',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'header',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'actions',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'text',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'trackingId',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PremiumFeaturesOverviewQuery,
  PremiumFeaturesOverviewQueryVariables
>;
